import React from 'react';
import { links } from '../data/site';
type LogoProps = {
  onClick?: () => void;
};
export function Logo({
  onClick
}: LogoProps) {
  return <a href="#top" onClick={onClick} aria-label="Thomas Consulting, Craig Thomas. Back to top" className="group flex items-center gap-3 shrink-0" data-id="element-76" data-mp="8ue9hmr4muih">
      {/* The mark is scaled slightly to crop the white margin baked into the image */}
      <span className="block w-10 h-10 sm:w-11 sm:h-11 overflow-hidden rounded-[10px] shrink-0" data-id="element-77" data-mp="mskzyhtqxs84">
        <img src={links.logo} alt="" aria-hidden="true" className="w-full h-full object-cover scale-[1.09]" data-id="element-78" data-mp="rs7dksdhlahg" />
      </span>
      <span className="flex flex-col leading-tight" data-id="element-79" data-mp="htrjcgj5xl3q">
        <span className="font-serif text-lg sm:text-xl text-ink group-hover:text-forest transition-colors duration-200 whitespace-nowrap" data-id="element-80" data-mp="hs6osqwum25v">
          Thomas Consulting
        </span>
        <span className="text-xs tracking-[0.08em] text-ink-mute whitespace-nowrap" data-id="element-81" data-mp="32l1r6eqj8hs6">
          Craig Thomas
        </span>
      </span>
    </a>;
}